import { useContext, useEffect, useMemo, useState } from "react";
import { GetEmergingNewIssues, UpdateStatusToExistingAsync } from "../Services/AdminService.ts";
import UserContext from "../Contexts/UserContext.ts";
import { Button, Col, Row } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import {  Checkbox, FormControl, IconButton, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, SelectChangeEvent, Tooltip } from "@mui/material";
import { getRegions } from "../Services/GetDropDownsData.ts";
import { Region } from "../Types/DropDownModels.ts";
import WarningDialog from "./Warningdialog.jsx";
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { pink, red } from "@mui/material/colors";
import { Margin } from "@mui/icons-material";

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

 const MenuProps = {
    PaperProps: {      
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
export default function NewEmergingIssues() {

    const userinfo = useContext(UserContext);
    // const [getIssues, setIssues] = useState<{id:number,subject:string,typeofEmergingIssues:TypeofEmergingIssue,status:IssueStatus,region:Region,enforcementDate:Date,enforcementDetails:string}[]>();
    const [getIssues, setIssues] = useState();
    const [regions, setRegions] = useState<Region[]>();
    const [regionIds, setRegionIds] = useState<number[]>([]);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        setTimeout(() => {
            setError('');
        }, 3000);
    }, [error]);

     useEffect(() => {
        setTimeout(() => {
            setSuccess('');
        }, 3000);
    }, [success]);

    const [isConfirmUpdate, setIsUpdate] = useState(false);
    const openUpdateConfirmation = () => { setIsUpdate(true) }
    const closeUpdateConfirmation = () => { setIsUpdate(false) }

const clearFilter=()=>{
    gridApi.setFilterModel(null);
    setRegionIds([]);
    localStorage.setItem("regionIds",'');
    getnewEmergingIssues([]);
}

    const getnewEmergingIssues = (ids: number[] | []) => {
        GetEmergingNewIssues(ids, userinfo.accessToken)
            .then(response => response.json())
            .then(resultData => {
                if (resultData) {
                    setIssues(resultData);
                }
                else {
                    console.log(resultData.message)
                }
            })
            .catch(error => {
                console.log(error)
            });
    }

    useEffect(() => {

        getRegions(userinfo.accessToken)
            .then(response =>
                response.json()
            )
            .then(resultData => {
                if (resultData && resultData.isSuccess) {
                    setRegions(resultData.data.result.sort((a, b) => {
                        if (a.order !== b.order) {
                            return a.order - b.order;
                        } else {
                            return a.name.localeCompare(b.name);
                        }
                    }));
                }
            })
            .catch(error => console.log(error));

        const _regionIds = localStorage.getItem("regionIds");
        if (_regionIds) {
            setRegionIds(JSON.parse(_regionIds));
        getnewEmergingIssues(JSON.parse(_regionIds));

        }
        else{
        getnewEmergingIssues([]);

        }


    }, []);


    const [columndefs] = useState([
        // { field: "id",headerName:'AIM ID',width:'100'},
        { field: "shortSubject", headerName: 'Subject', tooltipField: 'shortSubject', flex: 2, width: 350, checkboxSelection: true, headerCheckboxSelection: true,headerCheckboxSelectionFilteredOnly:true },
        { field: 'typeofEmergingIssue.name', headerName: 'Type of Issue', width: 100, filter: false, flex: 0.5 },
        { field: 'region.name', headerName: 'Region', width: 100, filter: false, flex: 0.5 },
        { field: 'status.name', headerName: 'Status', width: 100, filter: "agTextColumnFilter", flex: 0.49 },
        { field: 'enforcementDate', headerName: 'Enforcement Date', headerClass: 'textcenter', filter: false, flex: 0.6, valueGetter: params => params.data[params.colDef.field] == null ? "" : new Date(params.data[params.colDef.field]).toLocaleDateString("en-us", { month: 'short', year: 'numeric', day: 'numeric' }) },
        { field: 'enforcementDetails', headerName: 'Enforcement Details', width: 100, filter: "agTextColumnFilter", flex: 0.49 },
        { field: 'action.name', headerName: 'Action', filter: "agTextColumnFilter", flex: 0.8 },
        { field: 'createdDate', headerName: 'Created Date', headerClass: 'textcenter', filter: false, flex: 0.6, valueGetter: params => params.data[params.colDef.field] == null ? "" : new Date(params.data[params.colDef.field]).toLocaleDateString("en-us", { month: 'short', year: 'numeric', day: 'numeric' }) },
        { field: 'createdBy', headerName: 'Created By', headerClass: 'textcenter', filter: false, flex: 0.6}

    ]);

    const defaultColDef = useMemo(() => ({
        sortable: true
        , filter: true
        , wrapHeaderText: true
        // ,floatingFilter:true
        // ,resizable:true
    }), []);


    const rowHeight = 24;

    const perPage = 15;

    const [gridApi, setGridApi] = useState<GridApi>();

    const OnGridReady = params => {
        setGridApi(params.api);
        // getIssues();
    }


    const onChangeHandeler = (event: SelectChangeEvent<number[]>) => {
        const values = event.target.value as number[];
        setRegionIds(values);
        localStorage.setItem("regionIds",JSON.stringify(values));
        getnewEmergingIssues(values);
        
    }

    const OnSubmit = () => {
        const issueids:number[] = gridApi?.getSelectedRows().map(it => it.id);
        UpdateStatusToExistingAsync(gridApi?.getSelectedRows().map(it => it.id), userinfo.accessToken)
            .then(response =>
                response.json()
            )
            .then(result => {
                setIssues(getIssues?.filter(it=> !issueids.includes(it.id) ));
                setSuccess(result);
                console.log("Successfull");
            })
            .catch(error => console.log(error));

    }

    const UpdateIssues = () => {
        if (gridApi?.getSelectedRows().length <= 0) {
            setError("Select Atleast one Issue.")
        }
        else {
            openUpdateConfirmation();
        }
    }

    return <>
<Row style={{marginBottom:10}}>
    <Col xs='5'>
            {regions ? 

         <FormControl sx={{ width: '100%' }}>
                          <InputLabel id="outlined-size-small-label" className="labelbgwhite">Regions</InputLabel>
                          <Select
                            size="small"
                            labelId="outlined-size-small-label"
                            multiple
                            id="fontsizesmall"
                            name="regionids"
                            fullWidth
                            inputProps={{ MenuProps: { disableScrollLock: true } }}
                            value={regionIds}
                            input={<OutlinedInput label="Tag" />}
                            renderValue={() => regions.filter(it => regionIds && regionIds.indexOf(it.regionId) > -1).map(it => it.name).join(', ')}
                            onChange={onChangeHandeler}
                            MenuProps={MenuProps}
                        >
                            {regions.map((option) => (
                                <MenuItem key={option.regionId} value={option.regionId} style={{ padding: 0, paddingLeft: 16 }}>
                                    <Checkbox checked={regionIds && regionIds.indexOf(option.regionId) > -1} style={{ padding: 6 }} />
                                    <ListItemText primary={option.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    : ""}
            </Col>
            <Col xs='1'>
            <Tooltip title="Reset Filter">
                <IconButton onClick={()=>clearFilter()}>
                    <SearchOffIcon sx={{ color: pink[500] }} />
                </IconButton>
            </Tooltip>
            </Col>
            
            <Col>
                    {error && <p style={{color:'red',margin:0}}>{error}</p>}
                    {success && <p style={{color:'green',margin:0}}>{success}</p>}
            </Col>
            <Col xs='2' style={{textAlign:"right"}}>
                <Button onClick={UpdateIssues} className="mybtn font12 btnfitright" style={{ width: "auto" }} >Convert</Button>
            </Col>
</Row>
        <Row className="overflowauto" style={{ height: 485, paddingTop: 0, overflowY: "hidden" }}>
            <AgGridReact className="ag-theme-alpine mygrid"
                // domLayout={'autoHeight'}
                defaultColDef={defaultColDef}
                rowData={getIssues}
                animateRows={true}
                // cacheBlockSize={10}
                paginationPageSize={perPage}
                // onPaginationChanged={it => { setPageNumber(it.api.paginationGetCurrentPage() + 1); setPageSize(it.api.paginationGetPageSize()) }}
                pagination={true}
                rowHeight={rowHeight}
                headerHeight={38}
                enableBrowserTooltips={true}
                columnDefs={columndefs}
                onGridReady={OnGridReady}
                rowSelection={'multiple'}
                rowMultiSelectWithClick={true}
            />



        </Row>
        <WarningDialog confirmButtonName={"Update"} openconfirmation={openUpdateConfirmation} closeconfirmation={closeUpdateConfirmation} isdeleteconfirm={isConfirmUpdate} deleteitem={OnSubmit} message={`Are you sure you want to convert the selected issue type(s)? This action cannot be undone.`} />
        
    </>;
}

